import { render, staticRenderFns } from "./GrupoTipoBaixaList.vue?vue&type=template&id=4e629fce"
import script from "./GrupoTipoBaixaList.vue?vue&type=script&lang=js"
export * from "./GrupoTipoBaixaList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports